// Fuente única de nombres de módulos, grupos y pestañas; estilo: cada palabra con mayúscula, salvo preposiciones cortas.

export const NAV_GROUP_LABELS = {
  security: 'Seguridad',
  products: 'Productos',
  digitalServices: 'Servicios Digitales'
} as const

// Clave = segmento de la ruta del módulo (/admin/<clave>/…).
export const MODULE_LABELS = {
  usuarios: 'Usuarios',
  puestos: 'Puestos',
  empleados: 'Empleados',
  permisos: 'Permisos',
  roles: 'Roles',
  tiendas: 'Tiendas',
  'formas-de-pago': 'Formas de Pago',
  'secuencias-numericas': 'Secuencias Numéricas',
  productos: 'Catálogo Maestro',
  surtidos: 'Catálogo por Tienda',
  categorias: 'Categorías',
  'grupo-de-precios': 'Listas de Precio',
  'niveles-de-precio': 'Niveles de Precio',
  promociones: 'Promociones',
  proveedores: 'Proveedores',
  transacciones: 'Transacciones',
  clientes: 'Clientes'
} as const

export type ModuleKey = keyof typeof MODULE_LABELS

// Módulos que el menú agrupa bajo un encabezado sin página propia.
export const MODULE_GROUPS: Partial<Record<ModuleKey, string>> = {
  permisos: NAV_GROUP_LABELS.security,
  roles: NAV_GROUP_LABELS.security,
  productos: NAV_GROUP_LABELS.products,
  surtidos: NAV_GROUP_LABELS.products,
  categorias: NAV_GROUP_LABELS.products,
  'grupo-de-precios': NAV_GROUP_LABELS.products,
  'niveles-de-precio': NAV_GROUP_LABELS.products,
  proveedores: NAV_GROUP_LABELS.digitalServices,
  transacciones: NAV_GROUP_LABELS.digitalServices
}

export const OVERVIEW_TAB_LABEL = 'Resumen'

// Pestañas de cada módulo. Clave = segmento de la ruta de la pestaña (/admin/<módulo>/<id>/<clave>).
export const TAB_LABELS = {
  categorias: { subcategorias: 'Subcategorías' },
  clientes: { contactos: 'Contactos Relacionados', tiendas: 'Tiendas Autorizadas' },
  empleados: { asignaciones: 'Asignaciones' },
  'grupo-de-precios': { productos: 'Productos Asignados', tiendas: 'Tiendas Asignadas' },
  productos: {
    'codigos-de-barra': 'Códigos de Barra',
    'conversiones-de-unidad': 'Conversiones de Unidad',
    'grupo-de-precios': MODULE_LABELS['grupo-de-precios']
  },
  proveedores: { credenciales: 'Credenciales' },
  roles: { permisos: 'Permisos' },
  surtidos: { productos: 'Productos Asignados', tiendas: 'Tiendas Asignadas' },
  tiendas: { 'formas-de-pago': MODULE_LABELS['formas-de-pago'] },
  usuarios: { roles: 'Roles' }
} as const

// Ruta base de cada módulo. Es la única que conocen el menú, el breadcrumb y los enlaces a registros.
export const MODULE_ROUTES: Record<ModuleKey, string> = {
  usuarios: '/admin/usuarios',
  puestos: '/admin/puestos',
  empleados: '/admin/empleados',
  permisos: '/admin/seguridad/permisos',
  roles: '/admin/seguridad/roles',
  tiendas: '/admin/tiendas',
  'formas-de-pago': '/admin/formas-de-pago',
  'secuencias-numericas': '/admin/secuencias-numericas',
  productos: '/admin/productos/catalogo-maestro',
  surtidos: '/admin/productos/catalogo-por-tienda',
  categorias: '/admin/productos/categorias',
  'grupo-de-precios': '/admin/productos/listas-de-precio',
  'niveles-de-precio': '/admin/productos/niveles-de-precio',
  promociones: '/admin/promociones',
  proveedores: '/admin/servicios-digitales/proveedores',
  transacciones: '/admin/servicios-digitales/transacciones',
  clientes: '/admin/clientes'
}

export const LIST_ROUTE_SUFFIX = '/listar'
